import { useState } from "react";
import { toast } from "sonner";
import { Check, Clock, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import api, { errMsg, fmtDate, imageUrl } from "@/lib/api";

export default function DraftCard({ d, onDone }) {
  const [text, setText] = useState(d.text);
  const [busy, setBusy] = useState(false);

  const act = async (action) => {
    setBusy(true);
    try {
      if (action === "approve" && text !== d.text) await api.put(`/autopilot/drafts/${d.id}`, { text });
      await api.post(`/autopilot/drafts/${d.id}/${action}`);
      toast.success(action === "approve" ? `Diluluskan: ${d.group_name}` : "Draf ditolak");
      onDone();
    } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };

  return (
    <div className="rounded-lg border border-border bg-background/40 p-4" data-testid={`autopilot-draft-${d.id}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="min-w-0 truncate text-sm font-semibold">{d.group_name}</p>
        <span className="flex items-center gap-1 font-mono text-[11px] text-muted-foreground"><Clock className="h-3 w-3" />{fmtDate(d.scheduled_at)}</span>
      </div>
      <div className="mt-3 flex gap-3">
        {d.image_id && <img src={imageUrl(d.image_id)} alt="" className="h-14 w-14 rounded-md border border-border object-cover" />}
        <Textarea rows={5} value={text} onChange={(e) => setText(e.target.value)} className="flex-1 bg-background text-sm" data-testid={`autopilot-draft-text-${d.id}`} />
      </div>
      <div className="mt-3 flex gap-2">
        <Button size="sm" onClick={() => act("approve")} disabled={busy || !text.trim()} data-testid={`autopilot-draft-approve-${d.id}`}><Check className="mr-1.5 h-3.5 w-3.5" />Luluskan</Button>
        <Button size="sm" variant="ghost" className="text-red-300" onClick={() => act("reject")} disabled={busy} data-testid={`autopilot-draft-reject-${d.id}`}><X className="mr-1.5 h-3.5 w-3.5" />Tolak</Button>
      </div>
    </div>
  );
}
